/* eslint-disable react/prop-types */

import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Select from "react-select";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import NoSsr from "@material-ui/core/NoSsr";
import TextField from "@material-ui/core/TextField";
import Paper from "@material-ui/core/Paper";
import Chip from "@material-ui/core/Chip";
import MenuItem from "@material-ui/core/MenuItem";
import { emphasize } from "@material-ui/core/styles/colorManipulator";
import _ from "lodash";

const suggestions = [
  { label: "Andhra Pradesh", value: "01" },
  { label: "Andaman und Nico.In.", value: "26" },
  { label: "Arunachal Pradesh", value: "02" },
  { label: "Assam", value: "03" },
  { label: "Bihar", value: "04" },
  { label: "Chandigarh", value: "27" },
  { label: "Chhattisgarh", value: "33" },
  { label: "Dadra and Nagar Haveli", value: "28" },
  { label: "Daman and Diu", value: "29" },
  { label: "Delhi", value: "30" },
  { label: "Goa", value: "05" },
  { label: "Gujarat", value: "06" },
  { label: "Haryana", value: "07" },
  { label: "Himachal Pradesh", value: "08" },
  { label: "Jammu and Kashmir", value: "09" },
  { label: "Jharkhand", value: "34" },
  { label: "Karnataka", value: "10" },
  { label: "Kerala", value: "11" },
  { label: "Madhya Pradesh", value: "12" },
  { label: "Maharashtra", value: "13" },
  { label: "Manipur", value: "14" },
  { label: "Meghalaya", value: "15" },
  { label: "Mizoram", value: "16" },
  { label: "Nagaland", value: "17" },
  { label: "Orissa", value: "18" },
  { label: "Puducherry", value: "32" },
  { label: "Punjab", value: "19" },
  { label: "Rajasthan", value: "20" },
  { label: "Sikkim", value: "21" },
  { label: "Tamil Nadu", value: "22" },
  { label: "Telangana", value: "36" },
  { label: "Tripura", value: "23" },
  { label: "Uttaranchal", value: "35" },
  { label: "Uttar Pradesh", value: "24" },
  { label: "West Bengal", value: "25" }
].map(suggestion => ({
  value: `${suggestion.label} - ${suggestion.value}`,
  label: suggestion.label
}));

const styles = theme => ({
  root: {
    flexGrow: 1,
    height: 250
  },
  input: {
    display: "flex",
    padding: 0
  },
  valueContainer: {
    display: "flex",
    flexWrap: "wrap",
    flex: 1,
    alignItems: "center"
  },
  chip: {
    margin: `${theme.spacing.unit / 2}px ${theme.spacing.unit / 4}px`
  },
  chipFocused: {
    backgroundColor: emphasize(
      theme.palette.type === "light"
        ? theme.palette.grey[300]
        : theme.palette.grey[500],
      0.08
    )
  },
  noOptionsMessage: {
    padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`
  },
  singleValue: {
    fontSize: 16
  },
  placeholder: {
    position: "absolute",
    left: 2,
    fontSize: 16
  },
  paper: {
    marginTop: theme.spacing.unit
  },
  divider: {
    height: theme.spacing.unit * 2
  }
});

function NoOptionsMessage(props) {
  return (
    <Typography
      color="textSecondary"
      className={props.selectProps.classes.noOptionsMessage}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
}

function inputComponent({ inputRef, ...props }) {
  return <div ref={inputRef} {...props} />;
}

function Control(props) {
  return (
    <TextField
      fullWidth
      InputProps={{
        inputComponent,
        inputProps: {
          className: props.selectProps.classes.input,
          inputRef: props.innerRef,
          children: props.children,
          ...props.innerProps
        }
      }}
      {...props.selectProps.textFieldProps}
    />
  );
}

function Option(props) {
  return (
    <MenuItem
      buttonRef={props.innerRef}
      selected={props.isFocused}
      component="div"
      style={{
        fontWeight: props.isSelected ? 500 : 400
      }}
      {...props.innerProps}
    >
      {props.children}
    </MenuItem>
  );
}

function Placeholder(props) {
  return (
    <Typography
      color="textSecondary"
      className={props.selectProps.classes.placeholder}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
}

function SingleValue(props) {
  return (
    <Typography
      className={props.selectProps.classes.singleValue}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
}

function ValueContainer(props) {
  return (
    <div className={props.selectProps.classes.valueContainer}>
      {props.children}
    </div>
  );
}

function MultiValue(props) {
  return (
    <Chip
      tabIndex={-1}
      label={props.children}
      className={classNames(props.selectProps.classes.chip, {
        [props.selectProps.classes.chipFocused]: props.isFocused
      })}
      onDelete={event => {
        props.removeProps.onClick();
        props.removeProps.onMouseDown(event);
      }}
    />
  );
}

function Menu(props) {
  return (
    <Paper
      square
      className={props.selectProps.classes.paper}
      {...props.innerProps}
    >
      {props.children}
    </Paper>
  );
}

const components = {
  Option,
  Control,
  NoOptionsMessage,
  Placeholder,
  SingleValue,
  MultiValue,
  ValueContainer,
  Menu
};

class ReactSelect extends React.Component {
  state = {
    single: null,
    multi: null
  };

  handleChange = name => value => {
    this.setState({
      [name]: value
    });
  };

  render() {
    const { classes, theme, placeholderText } = this.props;

    const selectStyles = {
      input: base => ({
        ...base,
        color: theme.palette.text.primary
      })
    };
    const stateObject = _.filter(suggestions, {
      value: this.props.value.value
    });

    return (
      <NoSsr>
        <Select
          classes={classes}
          styles={selectStyles}
          options={
            this.props.suggestions ? this.props.suggestions : suggestions
          }
          components={components}
          placeholder={this.props.placeholderText}
          value={stateObject}
          onChange={this.props.onChange}
          isDisabled={this.props.isDisabled}
        />
      </NoSsr>
    );
  }
}

ReactSelect.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired
};

export default withStyles(styles, { withTheme: true })(ReactSelect);
